var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICusHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_751_68046)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1636 26.0004H6V23.4772C6 22.5222 6.3868 21.6753 7.08922 21.0925C7.73262 20.5586 8.61781 20.2646 9.58176 20.2646C10.5457 20.2646 11.4309 20.5586 12.0743 21.0925C12.7767 21.6753 13.1636 22.5222 13.1636 23.4772V26.0004H13.1636Z",
    fill: "#009981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1638 23.4772C13.1638 22.5222 12.777 21.6753 12.0745 21.0925C11.4311 20.5587 10.5459 20.2646 9.58203 20.2646V26.0004H13.1638V23.4772H13.1638Z",
    fill: "#00483D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58184 21.4361C8.3068 21.4361 7.26953 20.3988 7.26953 19.1238C7.26953 17.8488 8.30684 16.8115 9.58184 16.8115C10.8569 16.8115 11.8941 17.8488 11.8941 19.1238C11.8941 20.3988 10.8569 21.4361 9.58184 21.4361V21.4361Z",
    fill: "#FFB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58203 16.8115V21.4362C10.8571 21.4362 11.8943 20.3989 11.8943 19.1239C11.8943 17.8489 10.8571 16.8115 9.58203 16.8115V16.8115Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9995 26.0004H18.8359V23.4772C18.8359 22.5222 19.2227 21.6753 19.9252 21.0925C20.5686 20.5586 21.4537 20.2646 22.4177 20.2646C23.3816 20.2646 24.2668 20.5586 24.9102 21.0925C25.6127 21.6753 25.9995 22.5222 25.9995 23.4772V26.0004Z",
    fill: "#009981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9998 23.4772C25.9998 22.5222 25.6129 21.6753 24.9105 21.0925C24.2671 20.5587 23.3819 20.2646 22.418 20.2646V26.0004H25.9998V23.4772Z",
    fill: "#00483D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4178 21.4361C21.1427 21.4361 20.1055 20.3988 20.1055 19.1238C20.1055 17.8488 21.1428 16.8115 22.4178 16.8115C23.6928 16.8115 24.7301 17.8488 24.7301 19.1238C24.7301 20.3988 23.6928 21.4361 22.4178 21.4361Z",
    fill: "#FFB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.418 16.8115V21.4362C23.693 21.4362 24.7303 20.3989 24.7303 19.1239C24.7303 17.8489 23.693 16.8115 22.418 16.8115Z",
    fill: "#E59788"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 11.8625L18.2976 13.0703L17.8589 10.5122L19.7174 8.70059L17.149 8.32742L16.0003 6L14.8516 8.32742L12.2832 8.70059L14.1418 10.5122L13.703 13.0703L16.0003 11.8625Z",
    fill: "#FFB725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7171 8.70059L17.1487 8.32742L16 6V11.8625L18.2973 13.0703L17.8586 10.5122L19.7171 8.70059Z",
    fill: "#FF9000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6764 26.0003H10.3242V25.3778C10.3242 23.8576 10.913 22.5655 12.0268 21.6413C13.0466 20.7951 14.4577 20.3291 16.0002 20.3291C17.5427 20.3291 18.9538 20.7951 19.9737 21.6413C21.0876 22.5655 21.6764 23.8576 21.6764 25.3778V26.0003Z",
    fill: "#009981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6761 25.3778C21.6761 23.8576 21.0873 22.5655 19.9734 21.6413C18.9535 20.7951 17.5424 20.3291 16 20.3291V26.0003H21.6761V25.3778Z",
    fill: "#00483D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 21.5003C14.0592 21.5003 12.4805 19.9216 12.4805 17.9811C12.4805 16.0406 14.0592 14.4619 15.9996 14.4619C17.9402 14.4619 19.5189 16.0406 19.5189 17.9811C19.5189 19.9216 17.9402 21.5003 15.9996 21.5003V21.5003Z",
    fill: "#F9C4B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5192 17.9811C19.5192 16.0406 17.9405 14.462 16 14.4619V21.5003C17.9405 21.5002 19.5192 19.9216 19.5192 17.9811Z",
    fill: "#FFB19E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4077 14.8547L10.7039 12.8719L11.9382 11.1681L9.83512 11.2248L8.59609 9.52441L8 11.5422L6 12.195L7.73488 13.3854L7.73781 15.4894L9.40598 14.2073L11.4077 14.8547Z",
    fill: "#FFB725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4073 14.8546L10.7034 12.8718L11.9377 11.168L9.83465 11.2247L8.5957 9.52441L9.40551 14.2072L11.4073 14.8546Z",
    fill: "#FF9000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.593 14.8547L21.2968 12.8719L20.0625 11.1681L22.1656 11.2248L23.4046 9.52441L24.0007 11.5422L26.0007 12.195L24.2658 13.3854L24.2629 15.4894L22.5947 14.2073L20.593 14.8547Z",
    fill: "#FF9000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.593 14.8546L21.2968 12.8718L20.0625 11.168L22.1656 11.2247L23.4045 9.52441L22.5947 14.2072L20.593 14.8546Z",
    fill: "#FFB725"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_751_68046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICusHome);
export default __webpack_public_path__ + "static/media/i__cus_home.d99a3dae503f45bab15593c00f9f5ef7.svg";
export { ForwardRef as ReactComponent };